module.exports = __webpack_public_path__ + "img/category-popular.1fdaf7fa.png";